import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { UserContext } from "../../App";
import {
  getInvoicePdfBase64,
  pdfBase64ToBlob,
} from "../../store/actions/estimateActions";
import { invoiceStatus } from "./invoiceContent";
import {
  useExistingObject,
  useTarifsOptions,
} from "../../utils/estimate-invoice";
import CreateOrUpdateContentForm from "../../utils/estimate-invoice/CreateOrUpdateContentForm";
import Footer from "../../utils/estimate-invoice/Footer";
import { NavItem, NavTabs } from "../layout/Nav";

export default function InvoiceAddContent(props) {
  const params = useParams();
  const invoiceId = params.invoiceId;
  const { userInfos } = useContext(UserContext);

  const [loading, setLoading] = useState(false);

  const tarifs = useTarifsOptions();
  const rawInvoice = useExistingObject({
    userInfos,
    objectId: invoiceId,
    isEstimate: false,
    tarifs,
  });
  const [invoicePdfBase64, setInvoicePdfBase64] = useState(null);
  const [activeTab, setActiveTab] = useState("bookings");

  // region pdf generation
  useEffect(() => {
    if (rawInvoice?.status && rawInvoice?.status !== "draft") {
      getInvoicePdfBase64(invoiceId, userInfos.jwt)
        .then((pdf) => {
          setInvoicePdfBase64(pdf);
        })
        .catch((error) => {
          // Silently handle errors - don't show error 500
          console.error("Error loading invoice PDF:", error);
          setInvoicePdfBase64(null);
        });
    }
  }, [invoiceId, rawInvoice?.status, userInfos.jwt]);

  const pdfObjectUrl = useMemo(() => {
    if (invoicePdfBase64) {
      const blob = pdfBase64ToBlob(invoicePdfBase64);
      return URL.createObjectURL(blob);
    }

    return null;
  }, [invoicePdfBase64]);

  // endregion

  return (
    <div
      className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <div className="kt-subheader   kt-grid__item" id="kt_subheader">
        <div className="kt-container  kt-container--fluid ">
          <div className="kt-subheader__main">
            <h3 className="kt-subheader__title">
              {invoiceId ? "Détails de la facture" : "Créer une facture"}
            </h3>
            <div className="kt-subheader__breadcrumbs">
              <Link to="/" className="kt-subheader__breadcrumbs-home">
                <i className="flaticon2-shelter"></i>
              </Link>
              <span className="kt-subheader__breadcrumbs-separator"></span>
              <Link to="/invoices" className="kt-subheader__breadcrumbs-link">
                Factures
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div className="kt-portlet kt-portlet--tabs">
          <div className="kt-portlet__head">
            <div className="kt-portlet__head-label">
              <h3 className="kt-portlet__head-title">
                {invoiceId ? (
                  <>
                    N° de facture {invoiceId} (
                    {rawInvoice ? invoiceStatus[rawInvoice.status] : ""})
                  </>
                ) : (
                  <>Créer une facture</>
                )}
              </h3>
            </div>
          </div>
          <NavTabs className="titles m-4">
            <NavItem className={activeTab === "bookings" ? "active" : ""}>
              <button onClick={() => setActiveTab("bookings")}>Courses</button>
            </NavItem>
            {invoiceId && rawInvoice && rawInvoice.status !== "draft" && (
              <NavItem className={activeTab === "infos" ? "active" : ""}>
                <button onClick={() => setActiveTab("infos")}>PDF</button>
              </NavItem>
            )}
          </NavTabs>
          <div className="tab-content">
            <div
              style={{ display: activeTab === "bookings" ? "block" : "none" }}
            >
              <CreateOrUpdateContentForm
                rawObject={rawInvoice}
                tarifs={tarifs}
                isEstimate={false}
                loading={loading}
                setLoading={setLoading}
              />
            </div>
            <div style={{ display: activeTab === "infos" ? "block" : "none" }}>
              <div className="d-flex justify-content-center">
                <embed src={pdfObjectUrl} height="900px" width="600px" />
              </div>
              <Footer
                rawObject={rawInvoice}
                loading={loading}
                setLoading={setLoading}
                isEstimate={false}
                readOnly={rawInvoice?.id && rawInvoice?.status !== "draft"}
                createButton={null}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
